import { RobotoFont } from '../../../styles/fonts';
import { styled } from '@mui/material';

export const StyledContainer = styled('ul')(({ theme }) => ({
  display: 'flex',
  gap: '32px',
  margin: 0,
  padding: '0 24px',
  paddingInlineStart: '0px',
  listStyle: 'none',
  '@media only screen and (max-width: 768px)': {
    padding: '0 10px',
  },
}));

export const StyledKey = styled('li')(({ theme }) => ({
  minWidth: '150px',
  lineHeight: '14px',
  '& > span': {
    fontWeight: 700,
  },
}));

export const StyledValue = styled('li')(({ theme }) => ({
  width: 'fit-content',
  lineHeight: '32px',
  minWidth: '130px',
  color: '#7D8286',
  verticalAlign: 'center',
  '@media only screen and (max-width: 768px)': {
    lineHeight: '24px',
    margin: '3px 0',
  },
  '& > span': {
    fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
    fontSize: '18px',
    fontWeight: 300,
    '@media only screen and (max-width: 768px)': {
      lineHeight: '24px',
    },
  },
}));
